export class TideCpnt {
    
    constructor()
    {
        this.initializeTide();
    }
    
    initializeTide()
    {
        if( $( '.tides-header' ).length > 0 ) {
        
            $( '.tides-month-item' ).on( 'click', function() {
                var month = $( this ).attr( 'index' );
            
                $( '.tides-month-item' ).removeClass( 'active' );
            
                $( this ).addClass( 'active' );
            
                $.each( $( '.tides-container' ), function() {
                    $( this ).addClass( 'active' ).removeClass( 'active' );
                
                    if( $( this ).attr( 'data-month' ) == month ) {
                        $( this ).removeClass( 'active' ).addClass( 'active' );
                    }
                });
            });
        
            $( '.tides-body-item' ).hover( function() {
            
                var row = $( this ).attr( 'rel' );
                $( '.tides-body-item[rel="' + row + '"]' ).removeClass( 'hover' ).addClass( 'hover' );
            
            }, function() {
            
                var row = $( this ).attr( 'rel' );
                $( '.tides-body-item[rel="' + row + '"]' ).addClass( 'hover' ).removeClass( 'hover' );
            
            });
        
            var row = $( '.tides-container.active .tides-body-item.current' ).attr( 'rel' );
        
            $( '.tides-container.active .tides-body-item[rel="' + row + '"]' ).addClass( 'current' );
        
        }
    
    }
}
